import React, {useEffect, useState} from "react";
import Spinner from "../../components/Spinner";
import UserSchema from "./UserSchema";
import {translate} from "../../components/Language/Translate";
import FormValidation from "../Validation/FormValidation";
import {simpleRequest} from "../simpleRequest";
import {useDispatch, useSelector} from "react-redux";
import Auth from "../../helpers/auth";
import FormFields from "../FormFields";
import {Col, Row, Button} from "react-bootstrap";
import {fetchCompanyFromAPI} from "../../actions/currentCompany";

const UserEdit = ({user, setView, view}) => {
  const [variables, setVariables] = useState({});
  const [fieldSettings, setFieldSettings] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [serverError, setServerError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // const [data, setData] = useState({});
  const currentUser = useSelector(st => st.currentUser);
  const userStatus = currentUser?.userStatus || "";
  const companyId = useSelector(st => st.currentCompany)?.id;
  const dispatch = useDispatch();
  const isCorrectUser = user.username === currentUser?.username;
  const mayEdit = Auth.mayEdit(currentUser, user);

  console.log({isCorrectUser, mayEdit});

  console.log({userStatus, companyId, fieldSettings, variables});
  console.log(variables);

  useEffect(() => {
    const fetch = async () => {
      const fields = new UserSchema(companyId, userStatus).fields;
      delete fields.password;
      delete fields.confirmPassword;
      if (!mayEdit) delete fields.userStatus;
      setFieldSettings({...fields});
      const vars = {};
      Object.keys(fields).forEach(k => (vars[k] = user[k] || fields[k].initialValue));
      setVariables({...vars});
      (() => setIsLoading(false))();
    };
    if (isLoading) fetch();
  });
  if (isLoading) return <Spinner />;

  const handleSubmit = async e => {
    e.preventDefault();
    const formValidation = new FormValidation({
      fieldSettings,
      variables,
      setFieldErrors
    });
    if (!formValidation.valid) return;
    const data = (
      await simpleRequest({
        url: `users/${companyId}/${user.username}`,
        method: "patch",
        data: {...variables}
      })
    ).data;
    console.log({data});

    dispatch(fetchCompanyFromAPI(companyId));
    (() => setView("details"))();
  };

  const props = {
    fieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
    setServerError
  };

  return (
    <div className="m-2 p-3" style={{border: "1px solid grey", borderRadius: "5px"}}>
      <p>Form</p>
      <FormFields props={props} />
      <Row>
        <Col>
          <Button block className="btn btn-outline-dark" onClick={handleSubmit}>
            {translate("Submit")}
          </Button>
        </Col>
        <Col>
          <Button block className="btn btn-secondary" onClick={() => setView("details")}>
            {translate("Cancel")}
          </Button>
        </Col>
      </Row>
    </div>
  );
};
export default UserEdit;
